import { organizationUserDetailsApiAccessValidations } from "@utils/validation/organization/organization-user-details/organization-user-details-validation-util";
import { ValidationErrorComponent } from "./validation-error-component/validation-error-component";
import styles from "./validation-errors-container.less";

type AdvancedErrorContainerProps = {
    organizationUserDetailErrors: any;
    label: string;
}

export const ValidationErrorsContainer = ({ organizationUserDetailErrors, label }: AdvancedErrorContainerProps) => {

    return <div className={styles.validationErrorContainer}>
        <p>{label} must contains the following</p>

        {organizationUserDetailsApiAccessValidations.map((validator, index) => {
            return <ValidationErrorComponent key={`${validator.name}-${index}`}  validation={organizationUserDetailErrors[validator.name]}/>;
        })}
    </div>
}